import {
  TertiaryColor, boxShadow, maxTablet, maxWidth, maxWidth1170,
  midMobile,
  minTablet, noGutter, primaryColor, primaryFont,
  retina, retinaOne, scrollbar, wMedium, wMBold, primaryHeadingColor, statusBouncedColor, statusUnsubscribedColor, minWidthApp,
} from 'constants/utilsStyles';
import { createGlobalStyle } from 'styled-components';

const GeneralStyle = createGlobalStyle`
  .body-element {
    background-color: #f9f8f6;
  }
  .parent-container {
    margin-right: auto;
    margin-left: auto;
    width:100%;
  }
  .sub-container {
    background: #f9f8f6;
    box-shadow: ${boxShadow};
    border-radius: 8px;
    padding: 18px 8px 8px 0px;
    position: relative;
    .heading-div {
      padding-left: 34px;
      @media all and (max-width: ${maxWidth}), ${retina} {
       padding-left: 24px;
      }
      @media all and (max-width: ${maxTablet}) {
        padding-left: 15px;
      }
    }
    @media all and (max-width: ${maxTablet}) {
      padding: 10px 0px 8px 0px;
    }
    &.blockViewShow, &.listViewSHow {
      padding: 10px 8px 8px 0px;
    }
    &.mainContainer {
      height: 100% !important;
      &.shortHeight {
         height: auto !important;
        &.minWidthData {
          .aud-Infinite-scroll {
            min-height: calc(100% - 35px) !important;
          }
        }
      }
      .infinite-scroll-component__outerdiv {
        height: 100% !important;
      }
      .tileViewInfiniteDiv {
        max-height: calc(100% - 30px) !important;
        @media all and (max-width: ${maxWidth}), ${retina} {
          max-height: calc(100% - 25px) !important;
        }
     
      }
      .aud-Infinite-scroll {
        &.gridViewInfiniteDiv {
          max-height: calc(100% - 30px) !important;
        }
        &.contacts-tile-table {
          max-height: calc(100% - 55px) !important;
          @media all and (max-width: ${maxWidth}), ${retina} {
            max-height: calc(100% - 40px) !important;
          }
          &.minFlowShow {
            min-height: calc(100% - 55px) !important;
            @media all and (max-width: ${maxWidth}), ${retina} {
             min-height: calc(100% - 40px) !important;
            }
          }
        }
      }
      &.blockViewContainerList {
        min-height: 420px;
        @media all and (max-width: ${maxWidth}), ${retina} {
          min-height: 350px;
        }
        .aud-Infinite-scroll {
          max-height: calc(100% - 43px) !important; // block view detail and search screen
          @media all and (max-width: ${maxWidth}), ${retina} {
            max-height: calc(100% - 40px) !important; // block view detail and search screen
          }
        }
      }
      .table-width-decide {
        .body-table {
          @media all and (max-width: ${minWidthApp}) { 
            padding: 8px 0px 8px 24px;
          }
        }
      }
      .loader-wrapper-appear {
       padding-left: 0px;
      }
      .contacts-tile-table-wrapper {
        padding-right: 0px;
      }
      &.tableViewContainer {
        .contacts-tile-table {
          margin-right: 8px;
        }
      }
    }
    &.blockViewContainerList {
      .heading-div {
        padding-left: 30px;
      }
      .aud-Infinite-scroll {
        max-height: calc(100% - 65px) !important;
        @media all and (max-width: ${maxWidth}), ${retina} {
          max-height: calc(100% - 60px) !important;
        }
      }
      .table-width-decide {
        .body-table {
          @media all and (max-width: ${minWidthApp}) { 
            padding: 8px 0px 8px 24px;
          }
        }
      }
      .loader-wrapper-appear {
       padding-left: 0px;
      }
      .contacts-tile-table-wrapper {
        padding-right: 0px;
      }
    }

    &.tableViewContainer {
      padding: 18px 0px 8px 0px;
      .contacts-footer-wrapper {
        .expandable {
          .right-sidebar {
            /* query for safari browser */
            @media screen and (-webkit-min-device-pixel-ratio:0) {  
              height: 98% !important;
            }
          }
        }
      }
      .heading-div {
        padding-left: 24px;
        @media all and (max-width: ${maxTablet}) {
          padding-left: 15px;
        }
      }
      &.globalContactsView {
        @media all and (max-width: ${maxWidth}), ${retina} {
          height: 407px !important;
        }
      }
      .ant-table-body {
        padding-left: 24px;
        @media all and (max-width: ${maxWidth}), ${retina} {
         padding-left: 16px;
        }
      }
    }


  }
  .ant-checkbox-wrapper { 
    &:hover {
      border-color: #C3C3C3;
    }
    .ant-checkbox {
      &:hover {
        border-color: #C3C3C3;
      }
      .ant-checkbox-inner {
        border:2px solid #C3C3C3;
        width: 20px;
        height: 20px;
        border-radius:6px;
        @media all and (max-width: ${maxWidth}), ${retina} {
          width: 18px;
          height: 18px;
        }
      }
    }
    .ant-checkbox-checked {
      border-radius:0px;
      border:0px;
      &:after{
        background-color: transparent;
        border: 2px solid ${primaryColor};
        border-radius:6px;
      }
      .ant-checkbox-inner {
        background-color: #fff;
        border-color: #fff;
        border:2px solid ${primaryColor};
        &:after {
          border: 2px solid ${primaryColor};
          border-top: 0px;
          border-left: 0px;
          top: 45%;
          left: 25.5%;
        }
      } 
    }
  }
  .p-relative {
    position: relative;
  }
  .border-0 {
    border: none;
  }
  .weight-900 {
    font-weight: 900;
  }
  .index-one {
    z-index: 1;
  }
  .indexZero {
    z-index: 0 !important;
  }
  .d-flex {
    display:flex;
  }
  .align-items-center{
    align-items: center;
  }
  .d-none {
    display:none;
  }
  .justify-content-center {
    justify-content: center;
  }
  .justify-content-between {
    justify-content: space-between;
  }
   .justify-content-around {
    justify-content: space-around;
  }

  .justify-content-end, .justifyContentFlexEnd{
    justify-content: flex-end;
  }
  .flex-column{
    flex-direction: column;
  }
  .flex-row{
    flex-direction: row;
  }
  .radius-50 {
    border-radius: 50px !important;
  }
  .radius-25 {
    border-radius: 25px !important;
  }
  .radius-20 {
    border-radius: 20px !important;
  }
  .radius-10 {
    border-radius: 10px !important;
  }
  .width-100 {
    width:100%;
  }
  .w-50 {
    width: 50%;
    min-width: 50%;
  }
  .w-49 {
    width: 49%;
    min-width: 49%;
  }
  .w-100{
    width:100%;
    min-width:100%;
  }
  .w-70{
    width: 70%;
    min-width: 70%;
  }
  .w-80{
    width:80%;
    min-width:80%;
  }
  .w-90{
    width:90%;
    min-width:90%;
  }
  .text-center{
    text-align: center;
  }
  .text-right {
    text-align: right;
  }
  .text-left {
    text-align: left;
  }
  .h-100 {
    height: 100%;
  }
  .pl-c-0 {
    padding-left: 0px;
  }
  .mt-c-0 {
    margin-top: 0px !important;
  }
  .mb-c-0 {
    margin-bottom: 0px !important;
  }
  .pb-4{
    padding-bottom: 1.5rem!important;
  }
  .px-3{
    padding-left: 1rem!important;
    padding-right: 1rem!important;
  }
  .align-self-center {
    align-self: center!important;
  }
  button{
    cursor: pointer;
  }
  .mb-0 {
    margin-bottom: 0!important;
  }
  .mx-c-negative {
    margin-right: -9px;
    margin-left: -9px;
  }
  .mr-0{
    margin-right: 0!important;
  }
  .pr-0 {
    padding-right: 0 !important;
  }
  .ml-0{
    margin-left: 0!important;
  }
  .ml-1 {
    margin-left: 10px;
  }
  .ml-2 {
    margin-left: 20px;
  }
  .ml-3 {
    margin-left: 30px;
  }
  .ml-4 {
    margin-left: 40px;
  }
  .ml-5 {
    margin-left: 50px;
  }
  .mr-1 {
    margin-right: 10px;
  }
  .mr-2 {
    margin-right: 20px;
  }
  .mr-3 {
    margin-right: 30px;
  }
  .mr-4 {
    margin-right: 40px;
  }
  .mr-5 {
    margin-right: 50px !important;
  }
  .mt-c-6 {
   margin-top: 6px;
  }
  .mt-c-10 {
   margin-top: 10px;
  }
  .mt-c-5 {
   margin-top: 5px;
  }
  .mt-c-15 {
   margin-top: 15px;
  }
  .mt-c-20 {
   margin-top: 20px;
  }
  .mtC20 {
    margin-top: 20px;
  }
  .mt-c-25 {
   margin-top: 25px;
  }
  .mt-c-30 {
   margin-top: 30px;
  }
  .mt-c-32 {
    margin-top: 32px;
  }
  .mt-c-40 {
   margin-top: 40px;
  }
  .mt-c-50 {
   margin-top: 50px;
  }
  .mb-c-5 {
    margin-bottom: 5px;
  }
  .mb-c-10 {
    margin-bottom: 10px;
  }
  .mbC10 {
    margin-bottom: 10px !important;
  }
  .mb-c-15 {
   margin-bottom: 15px;
  }
  .mb-c-20 {
   margin-bottom: 20px;
  }
  .mb-c-30 {
   margin-bottom: 30px;
  }
  .mb-c-40 {
   margin-bottom: 40px;
  }
  .mb-c-50 {
   margin-bottom: 50px;
  }
  .ml-c-5 {
    margin-left: 5px;
  }
  .ml-c-10 {
    margin-left: 10px;
  }
  .ml-c-15 {
   margin-left: 15px;
  }
  .ml-c-1 {
    margin-left: 3px !important;
  }
  .ml-c-20 {
   margin-left: 20px;
  }
  .ml-c-30 {
   margin-left: 30px;
  }
  .ml-c-40 {
   margin-left: 40px;
  }
  .ml-c-50 {
   margin-left: 50px;
  }
  .m-x-y-c-0 {
    margin: 0 0 !important;
  }
  .px-0 {
    padding: 0px !important;
  }
  .px-0-res-1_5 {
    padding: 0px 90px !important;
    @media all and (max-width: ${maxWidth}) , ${retina} { 
      padding: 0px !important;
    }
  }
  .px-1 {
    padding: 0px 10px;
  }
  .px-2 {
    padding: 0px 20px;
  }
  .px-3 {
    padding: 0px 30px;
  }
  .px-4 {
    padding: 0px 40px;
  }
  .px-5 {
    padding: 0px 50px;
  }
  .py-1 {
    padding: 10px 0px;
  }
  .py-2 {
    padding: 20px 0px;
  }
  .py-3 {
    padding: 30px 0px;
  }
  .py-4 {
    padding: 40px 0px;
  }
  .py-5 {
    padding: 50px 0px;
  }
  .o-hidden, .oHidden {
    overflow: hidden;
  }
  .line-block {
    display: inline-block !important;
  }
  .h-auto {
    height: auto !important;
  }
  .headers-space {
    margin-bottom: 25px;
  }
  .box-shadow {
    box-shadow: ${boxShadow} !important;
  }
  .f-size-16 {
    font-size: 16px !important;
  }
  .account-activity-wrapper {
    padding-top: 24px;
  }
 .text-truncate {
	 overflow: hidden;
	 text-overflow: ellipsis;
	 white-space: nowrap;
  }
  .text-truncate-one-line {
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    word-wrap: break-word;
  }
  .text-truncate-two-line {
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    word-wrap: break-word;
  }
  .text-truncate-three-line {
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    word-wrap: break-word;
  }
  .text-truncate-four-line {
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    word-wrap: break-word;
  }
  .left-separator {
    border-left: 1.5px solid ${TertiaryColor};
    margin-left: 10px;
    padding-left: 10px;
    @media all and (max-width: ${maxWidth1170}) {
      margin-left: 5px;
      padding-left: 5px;
    }
  }
  .leftSeparator {
    border-left: 1.5px solid ${TertiaryColor};
    margin-left: 10px;
    padding-left: 10px;
  }
  .no-gutters {
    margin-left: 0px !important;
    margin-right: 0px !important;
    padding: 0px 12px !important;
    .ant-col {
      padding-left: 0px !important;
      padding-right: 0px !important;
    }
  }
  .aud-Infinite-scroll {
    /* this is for contacts section */
     max-height: calc(100% - 60px) !important;
      @media all and (max-width: ${maxWidth}), ${retina} {
        max-height: calc(100% - 45px) !important;
      }
    &.emptyStateDashboard {
      @media all and (max-width: ${maxWidth}), ${retina} {
        max-height: calc(100% - 70px) !important;
      }
    }

    &.minFlowShow {
      min-height: calc(100% - 55px) !important;
      @media all and (max-width: ${maxWidth}), ${retina} {
        min-height: calc(100% - 40px) !important;
      }
    }

    &.gridViewInfiniteDiv {
      max-height: calc(100% - 85px) !important;
      @media all and (max-width: ${maxWidth}), ${retina} {
        max-height: calc(100% - 50px) !important;
      }
      &.limitedStats {
         max-height: calc(100% - 60px) !important;
        @media all and (max-width: ${maxWidth}), ${retina} {
          max-height: calc(100% - 32px) !important;
        }
      }
    }

    /* &.emptyState {
      height: 100% !important;
    } */

    &.tileViewInfiniteDiv {
      max-height: calc(100% - 72px) !important;
      height: 100% !important; // fix for one list in first screen
      @media all and (max-width: ${maxWidth}), ${retina} {
        max-height: calc(100% - 50px) !important;
      }
    }
    &.height-block {
      min-height: auto;
      max-height: 245px !important;
    }
    overflow-y: auto;
    overflow-x: hidden !important;
    border-radius: 0px !important;
    ${scrollbar};
  }
  .list-card-popover {
    .ant-popover-content {
      .ant-popover-inner {
        border-radius: 13px;
        padding: 0px;
        .ant-popover-title {
          border-bottom: 0px;
          padding: 20px 16px 13px;
          padding-bottom: 0px;
          &:hover {
            &:nth-child(1) {
              border-radius: 12px 12px 0px 0px !important;
            }
            &:nth-child(2) {
              border-radius: 0px 0px 12px 12px !important;
            }
          }
          .title-div {
            display: flex;
            flex-direction: column;
            .title-text {
              display: flex;
              align-items:center;
              &.edit-text {
                white-space: nowrap;
                &:hover {
                  color: ${primaryColor};
                  .edit-icon {
                    path {
                      fill: ${primaryColor};
                    }
                  }
                  &:nth-child(1) {
                    border-radius: 12px 12px 0px 0px !important;
                  }
                  &:nth-child(2) {
                    border-radius: 0px 0px 12px 12px !important;
                  }
                }
              }
              &.clone-text {
                &:hover {
                  color: ${primaryColor};
                  .clone-icon {
                    path {
                      fill: ${primaryColor};
                    }
                  }
                }
              }
              .clone-icon {
                margin-right: 9px;
                width: 14px;
                height: 14px;
              }
              .edit-icon {
                margin-right: 9px;
                width: 14px;
                height: 14px;
              }
              font-family: ${primaryFont};
              font-weight: ${wMBold};
              line-height: 16px;
              font-size: 16px;
              color:${TertiaryColor};
              margin-bottom: 13px;
              cursor: pointer;
              @media all and (max-width: ${maxWidth}), ${retina} {
                font-size: 14px;
                line-height: 20px;
              }
            }
          }
        }
        .ant-popover-inner-content {
          border-bottom-left-radius: 13px;
          border-bottom-right-radius: 13px;
          padding: 0px 16px 20px;
          .content-div {
            display: flex;
            flex-direction: column;
            .export-icon-sg {
              margin-right: 9px;
              width: 14px;
              height: 14px;
            }
            .delete-icon {
              margin-right: 9px;
              width: 14px;
              height: 16px;
            }
            .content-text {
              display:flex;
              align-items:center;
              &.export-text {
                &.curserNot {
                  cursor: not-allowed;
                   &:hover {
                    color: #7E7E7E !important;
                    svg {
                      path {
                        fill: #7E7E7E !important
                      }
                    }
                   }
                }
                &:hover {
                  color: ${primaryColor};
                  .export-icon-sg { 
                    path {
                      fill: ${primaryColor};
                    }
                  }
                }
              }
              &.delete-text {
                &:hover {
                  color: ${primaryColor};
                  .delete-icon {
                    path {
                      fill: ${primaryColor};
                      stroke: ${primaryColor};
                    }
                  }
                }
              }
              font-family: ${primaryFont};
              font-weight: ${wMedium};
              line-height: 16px;
              font-size: 16px;
              color:${TertiaryColor};
              cursor: pointer;
              @media all and (max-width: ${maxWidth}), ${retina} {
                font-size: 14px;
                line-height: 20px;
              }
              &:first-child {
                margin-bottom: 13px;
              }
            }
          }
        }
      }
    }
  }
  .contact-card-popover {
    z-index: 1 !important;
    .ant-popover-content {
      .ant-popover-inner {
      border-radius: 13px;
      padding: 0px;
      min-height: auto;
      .ant-popover-title {
        &:hover {
          color: ${primaryColor};
          &:nth-child(1) {
            border-radius: 12px 12px 0px 0px !important;
          }
          &:nth-child(2) {
            border-radius: 0px 0px 12px 12px !important;
          }
        }
        font-family: ${primaryFont};
        font-weight: ${wMBold};
        line-height: 16px;
        font-size: 16px;
        color:${TertiaryColor};
        border-bottom: 0px;
        padding: 20px 20px 16px 20px;
        cursor: pointer;
        @media all and (max-width: ${maxWidth}), ${retina} {
          font-size: 14px;
          line-height: 22px;
        }
      }
      .ant-popover-inner-content {
        border-bottom-left-radius: 13px;
        border-bottom-right-radius: 13px;
        padding: 0;
        .edit-text {
          &:hover {
            color: ${primaryColor};
            background-color: #f8f8f8;
            border-bottom: 1px solid #eee;
            &:nth-child(1) {
              border-radius: 12px 12px 0px 0px !important;
            }
            &:nth-child(2) {
              border-radius: 0px 0px 12px 12px !important;
            }
          }
          white-space: nowrap;
          font-family: ${primaryFont};
          font-weight: ${wMBold};
          line-height: 16px;
          font-size: 16px;
          color:${TertiaryColor};
          cursor: pointer;
          padding: 16px 20px 20px 20px;
          @media all and (max-width: ${maxWidth}), ${retina} {
            font-size: 14px;
            line-height: 22px;
          }
          &:nth-child(2) {
            border-radius: 0px 0px 13px 13px;
          }
        }
      }
    }
  }
  }
  .filter-dropdown { 
    min-width: 170px !important;
    .ant-dropdown-menu {
      padding: 15px 10px;
    }
  }
  .audience-module-row {
    margin-right: 0px !important;
    margin-left: 0px !important;
    padding: 0px 10px 0px 24px !important;
    @media all and (max-width: ${maxWidth}), ${retina} {
      ${noGutter};
    }
    @media all and (max-width: ${minWidthApp}) {
      padding: 0px 10px 0px 15px!important;
    }
    /* @media all and (max-width: ${maxTablet}) {
      padding: 0px 0px !important;
    } */
    .audience-module-col {
      &.tileViewCol {
        padding-left: 0px !important;
        padding-right: 0px !important;
      }
      &.gridCol {
        padding-left: 0px !important;
        padding-right: 0px !important;
        flex: 0 0 25%;
        max-width: 25%;
        .inner-content {
          position: relative;
          height: 150px;
          border-radius: 0px 0px 14px 14px;
          @media all and (max-width: ${maxWidth}), ${retina} {
           height: 135px;
          }
        }
        .list-card-footer-global {
          position: absolute;
          width: 90%;
          bottom: 15px;
        }
        @media all and (max-width: ${maxWidth}), ${retinaOne} {
          flex: 0 0 20%;
          max-width: 20%;
        }
        @media all and (max-width: ${maxWidth}), ${retina} {
          flex: 0 0 25%;
          max-width: 25%;
        }
        @media all and (max-width: ${maxWidth1170}) {
          flex: 0 0 33.3%;
          max-width: 33.3%;
        }
        @media all and (max-width: ${minTablet}) {
          flex: 0 0 50%;
          max-width: 50%;
        }
        @media all and (max-width: ${midMobile}) {
          flex: 0 0 100%;
          max-width: 100%;
        }
      }
    }
  }
  .disabled{ 
    opacity: 0.5;
    pointer-events: none;
  }
  .skeleton-box-global {
      display: inline-block;
      height: 1em;
      position: relative;
      overflow: hidden;
      background-color: #e9e9e9;
      &.redius-1 {
        border-radius: 10px;
      }
      &:after {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        -webkit-transform: translateX(-100%);
        transform: translateX(-100%);
        background-image: -webkit-gradient(
          linear,
          left top,
          right top,
          color-stop(0, rgba(255, 255, 255, 0)),
          color-stop(20%, rgba(255, 255, 255, 0.2)),
          color-stop(60%, rgba(255, 255, 255, 0.5)),
          to(rgba(255, 255, 255, 0))
        );
        background-image: linear-gradient(
          90deg,
          rgba(255, 255, 255, 0) 0,
          rgba(255, 255, 255, 0.2) 20%,
          rgba(255, 255, 255, 0.5) 60%,
          rgba(255, 255, 255, 0)
        );
        -webkit-animation: shimmer 2s infinite;
        animation: shimmer 2s infinite;
        content: "";
      }
  }
  .d-flex-column-center {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .d-flex-row-center-between {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
  .content-inner {
    .ant-popover {
      .ant-popover-content {
        .ant-popover-arrow {
          /* top: 7px;
          display: none; */
        }
      }
    }
    .ant-popover-inner {
      border-radius: 8px;
      background: #FFF;
      box-shadow: 0px 0px 40px 0px rgba(0, 0, 0, 0.28);
      width: auto;
    }
    .heading {
      color: #424B50;
      font-family: 'Roboto slab';
      font-size: 18px;
      font-style: normal;
      font-weight: 700;
      line-height: 22px; /* 122.222% */
      letter-spacing: -0.45px;
    }
  }
  /* .aud-Infinite-scroll {
    max-height: 245px;
    min-height: 100px;
    overflow-y: auto !important;
    overflow-x: hidden !important;
  } */
  .ai-type-tag {
    font-size: 9px !important;
    width: 18px;
    height: 18px;
    background-color: #979797;
    border-radius: 50%; 
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    display: inline-flex;
    margin-left: 4px;
    margin-top: -2px;
    position: absolute;
    right: -5px;
    top: 15px;
    &.styling-tag {
    margin-right: 5px;
    }

    &.Dominant {
      background: #F5222D;
    }
    &.Influencer {
      background: #FAAD14;
    }
    &.Steady {
      background: #52C41A;
    }
    &.Conscientious { 
      background: #1890FF;
    }

    .logo-img {
      height: 18px;
      width: 18px;
      min-width: 18px;
    }
  }
  .list-dropdown-ai {
    .checked-wrap {
    display: flex;
    align-items: center;
    }
  }
  .empty-email-wrap {
    padding: 30px 0px;
  }
  .class-for-blank-tip {
    max-width: fit-content;
  }
  /* .IndexHigh {
    .black-overlay  {
      pointer-events: none;
    }
  } */
  .contact-tile-company {
      font-family: ${primaryFont};
      font-weight: ${wMedium};
      font-size: 16px;
      line-height: 18px;
      margin-bottom: 0px;
      color: ${primaryHeadingColor};
      .contact-tile-company-div {
        margin-bottom: 0px;
      }
    }
    .contact-tile-status {
      font-family: ${primaryFont};
      font-weight: ${wMBold};
      font-size: 14px;
      line-height: 16px;
      margin-bottom: 0px;
      color: ${primaryColor};
      &.hard-bounce {
        color: ${statusBouncedColor};
      }
      &.unsubscribed {
        color: ${statusUnsubscribedColor};
      }
    }
    .status-wrapper {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .status-wrapper_inner {
        display: flex;
        .aud-action {
          cursor: pointer;
        }
      }
    }
    .engagement-score-wrapper {
      justify-content: end;
    }
    .ant-empty-description {
      color: #5E7079;
      font-family: 'Roboto';
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 17.2px; /* 112.5% */
      letter-spacing: -0.319px;
    }
    .no-data-found {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      margin-top: 70px;
      margin-bottom: 70px;
    }
    .blockViewShow {
      .heading-div {
        @media all and (max-width: ${maxWidth}), ${retina} {
         padding-left: 34px;
        }
      }
    }
    .visible-scroll {
     width: 370px;
     scrollbar-width: thin;
     scrollbar-color: #001760 #efefef;
     overflow-x: hidden;
      &::-webkit-scrollbar {
        width: 5px;
        height: 5px;
        border-radius: 5px;
      }
        /* Track */
      &::-webkit-scrollbar-track {
        background: #fff;
        margin-top: 10px;
        margin-bottom: 15px;
      }
        /* Handle */
      &::-webkit-scrollbar-thumb {
        background: #001760;
      }
        /* Handle on hover */
      &::-webkit-scrollbar-thumb:hover {
        background: #efefef;
      } 
    }
  .save-as-draft-ai {
    .ant-popover-inner-content{
      color: #424B50;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        font-size: 12px;
      }
    }
  }
  .tailored-content-popup {
    .ant-popover-inner-content{
      color: #424B50;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        font-size: 12px;
      }
    }
  }
  `;
export default GeneralStyle;
